<template>
    <div>
      <data-table
          :url="url"
          :title="title"
          :objects="objectsParsed"
          :schema="schemas[schema]"
          :totalItems="count"
          :fields="selectedHeaders"
          :ordering="[]"
          :alias="{
            'status_verbose': 'status',
            'container_type_str': 'Container Type',
            'last_alert_code': 'Last Event',
            'client_code': 'Client Code',
            'carrier_name': 'Carrier',
            'bl_or_booking_number': 'BL / Booking',
            'pol_loc': 'POL',
            'pod_loc': 'POD',
            'etd': 'ETD',
            'atd': 'ATD',
            'dtd': 'DTD',
            'eta': 'ETA',
            'ata': 'ATA',
            'dta': 'DTA',
            'storage_days_at_pol': 'Storage days at POL',
            'storage_days_at_pod': 'Storage days at POD',
            'discrepancy_eta_at_pod': 'DTAcP',
            'discrepancy_eta_at_dlv': 'DTAcD',
            'days_in_tsp': 'DTSP',
            'days_in_tsp_planned': 'DTSP Planned',
            'days_in_pod_planned': 'DPOD Planned',
            'days_in_pol_planned': 'DPOL Planned',
            'created_at': 'Created',
            'sf_data': 'C. Form',
          }"
          :mappers="{'health': HEALTH}"
          :tooltips="{
            'last_alert_code': 'last_alert_message',
            'sf_data': 'sf_data'
          }"
          >
      </data-table>
      <pagination
        :currentPage.sync="page"
        :totalItems="count"
        :itemsPerPage="pageSize"
        />
    </div>
</template>
<script>
import {mapState} from 'vuex'
import DataTable from '@/components/DataTable'
import Pagination from '@/components/Pagination'
import Shipment from '@/models/shipment'
export default {
  name: 'BiTable',
  components: {DataTable, Pagination},
  data () {
    return {
      host: '',
      HEALTH: Shipment.HEALTH,
      schemas: {shipment: Shipment.schema()},
      models: {shipment: Shipment},
      pageSize: 30,
      page: 1,
      selectedHeaders: []
    }
  },
  created () {
    this.host = window.location.hostname
    this.host = this.host.substring(0, this.host.indexOf('.'))
  },
  computed: {
    ...mapState({
      count: state => state.bi.count_table
    }),
    objectsParsed () {
      var ModelClass = this.models[this.schema]
      return this.objects.map(x => { return new ModelClass(x) })
    }
  },
  props: {
    objects: { type: Array, required: true },
    url: { type: String },
    title: { type: String },
    entity: { type: String },
    columns: { type: Array, required: true },
    schema: { type: String },
    pageNum: { type: Number },
    userInfo: { type: Object }
  },
  watch: {
    page: function (val) {
      if (val !== 1 || this.pageNum !== 0) {
        this.$emit('loadPage', this.page)
      }
    },
    pageNum: {
      handler (val) {
        if (val === 0) {
          this.page = 1
        }
      },
      deep: true
    }
  },
  mounted () {
    this.loadHeaders()
  },
  methods: {
    loadHeaders () {
      this.selectedHeaders = this.columns
      if (this.userInfo && this.userInfo.userprofile && this.userInfo.userprofile[this.entity + '_fields']) {
        this.selectedHeaders = this.userInfo.userprofile[this.entity + '_fields']
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/BiTable.vue